<div class="audio-player-container">
  <div class="column add-bottom" [hidden]="noSupportHtml5Audio">
    <div id="mainwrap" class="row d-flex align-items-center">
      <div id="nowPlay" class="col-md-2">
        <span class="text-dark ms-3">{{action}}</span>
      </div>
      <div id="audiowrap" class="col-md-6">
        <div tabindex="0" class="row d-flex align-items-center">
          <div class="col-md-4 d-flex justify-content-center tracks">
            <button class="btn btn-sm music-control" (click)="first()">
              <i class="bi bi-chevron-bar-left"></i>
            </button>
            <button class="btn btn-sm music-control" (click)="prev()">
              <i class="bi bi-chevron-left"></i>
            </button>
            <button class="btn btn-sm music-control" type="button" [class.active]="isRepeat" (click)="toggleReplay()">
              <i class="bi bi-arrow-counterclockwise"></i>
            </button>
            <button class="btn btn-sm music-control" type="button" [class.active]="isShuffle" (click)="toggleShuffle()">
              <i class="bi bi-shuffle"></i>
            </button>
            <button class="btn btn-sm music-control" type="button" (click)="togglePlay(audio)">
              <i class="bi bi-play" *ngIf="audio.paused; else pauseBlock"></i>
              <ng-template #pauseBlock>
                <i class="bi bi-pause"></i>
              </ng-template>
            </button>
            <button class="btn btn-sm music-control" (click)="next()">
              <i class="bi bi-chevron-right"></i>
            </button>
            <button class="btn btn-sm music-control" (click)="last()">
              <i class="bi bi-chevron-bar-right"></i>
            </button>
          </div>
          <div class="col-md-5 d-flex justify-content-center">
            <input
              style="width: 80%"
              class="mr-2"
              type="range"
              autocomplete="off"
              role="slider"
              [min]="0"
              [max]="audio.duration"
              [step]="'1'"
              [value]="audio.currentTime"
              [disabled]="audio.paused"
              (input)="jump(audio, $event)"
            />
            <span style="width: auto" class="text-dark d-inline-block"
              >{{audio.currentTime | duration}}&nbsp;/&nbsp;{{audio.duration | duration}}</span
            >
          </div>
          <div class="col-md-2 d-flex justify-content-center px-0">
            <button type="button" class="btn btn-sm music-control" style="font-size: 1.5rem" (click)="toggleMute(audio)">
              <i class="bi bi-volume-mute-fill" *ngIf="audio.muted || !audio.volume; else muteBlock"></i>
              <ng-template #muteBlock>
                <i class="bi bi-volume-up-fill"></i>
              </ng-template>
            </button>
            <input
              class="w-100 music-control"
              type="range"
              min="0"
              max="1"
              step="0.05"
              autocomplete="off"
              role="slider"
              [value]="audio.volume"
              (input)="changeVolume(audio, $event)"
            />
          </div>
          <div class="col-md-1 d-flex justify-content-center">
            <a class="btn btn-sm music-control text-dark" [href]="audio.src" target="_blank">
              <i class="bi bi-download"></i>
            </a>
            <audio
              #audio
              [controls]="true"
              id="audio1"
              preload
              controls
              (loadedmetadata)="onLoadMetadata()"
              (play)="onPlay()"
              (pause)="onPause()"
              (ended)="onEnded()"
              (error)="removeAudio(currentTrackIndex, true)"
            >
              Your browser does not support HTML5 Audio! 😢
            </audio>
          </div>
        </div>
      </div>
      <div id="plwrap" class="col-md-4">
        <div #audioList="ngbDropdown" ngbDropdown class="w-100 d-flex align-items-center" [autoClose]="'outside'">
          <div class="d-inline-block" style="width: 20%">
            <button class="btn btn-primary d-inline-block" id="dropdownConfig" ngbDropdownToggle>
              <i class="bi bi-music-note-list"></i>&nbsp;
              <i class="bi bi-caret-up-fill" *ngIf="audioList._open; else caretRight"></i>
              <ng-template #caretRight>
                <i class="bi bi-caret-right-fill"></i>
              </ng-template>
            </button>
          </div>
          <div class="scrolling-text-container" style="width: 80%">
            <div class="scrolling-text">{{ tracks[currentTrackIndex] | songScrollingTitle }}</div>
          </div>
          <ul ngbDropdownMenu id="plList" aria-labelledby="dropdownConfig" tabindex="0">
            <li
              ngbDropdownItem
              *ngFor="let track of tracks; index as i"
              (click)="playTrack(i, track); $event.stopPropagation()"
              [class.plSel]="currentTrackIndex === i"
            >
              <div class="plItem">
                <span class="plNum">{{i + 1}}.</span>
                <div class="plTitle">
                  <span>{{track.title}}</span><br />
                  <small>{{track.artist}}</small>
                </div>
                <span class="plLength">{{track.duration | duration}}</span>
                <button class="btn btn-sm btn-close-white" (click)="removeAudio(i)">
                  <i class="bi bi-x-circle-fill"></i>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <p *ngIf="noSupportHtml5Audio" class="no-support">{{audioRef.nativeElement.textContent}}</p>
  </div>
</div>
